import { ChangeDetectorRef, Component, ElementRef, ViewChild, HostListener, HostBinding } from '@angular/core';
import { Chart, ChartDataset } from 'chart.js/auto';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { ToastrService } from 'ngx-toastr';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getmonths } from 'src/app/shared/helpers/Drop-down-options';
import { getShipNameOptions, getRecordsOptions } from 'src/app/shared/helpers/dropdown-options';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { PrintReportComponent } from './pages/print-report/print-report.component';
Chart.register({
  id: 'showNoDataMessage',
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx;

    const cargoDataset = chart.data.datasets.find(ds => ds.label === 'Cargo Temp');
    const forecastDataset = chart.data.datasets.find(ds => ds.label === 'Forecast Temp');

    if (!cargoDataset || !forecastDataset) return;

    const cargoData = cargoDataset.data;
    const forecastData = forecastDataset.data;

    // Check if both Cargo and Forecast datasets are empty
    const hasCargoData = cargoData.some(value => value !== null && value !== 0);
    const hasForecastData = forecastData.some(value => value !== null && value !== 0);

    // If both datasets are empty, show the "No Data" message
    if (!hasCargoData && !hasForecastData) {
      const { width, height } = chart;

      ctx.save();
      ctx.fillStyle = '#888'; // Color for "No Data"
      ctx.font = 'bold 18px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('No Data Available', width / 2, height / 2); // Position in the center of the chart
      ctx.restore();
    }
  }
});


interface dummyData {
  DATE: number;
  AVG_CARGO: number | null;
  AIR_TEMP: number | null;
  Sea_Water_TEMP: number | null;
}
interface CargoEntry {
  Cargo: string;
  qty: number;
  load_port: string;
  disch_port: string;
  load_temp: number;
  melt_pt: number;
  voyage_min: number;
  voyage_max: number;
  discharge_min: number;
  discharge_max: number;
  master_dates: number[];
  Avg_Temp: (number | null)[];
}
//27
export interface TankData {
  data: any;

  No_Tanks: string;
  Voy_Range_Min: number;
  Voy_Range_Max: number;
  Disch_Range_Min: number;
  Disch_Range_Max: number;
  Melt_Pts: number;
  Load_Pts: number;
  cargo_detail_list: string;
  master_dates: number[];
  cargo_temp: number[];
  AVR_FCT: number[];
}

export type TankDataArray = TankData[];

interface TransformedCargoData {
  [key: string]: CargoEntry;
}
interface dataSecond {
  air_temp: number | null;
  sea_water_temp: number | null;
  forcast_temp: number | null;
  master_dates: any;
}
interface TransformedForcastoData {
  [key: string]: dataSecond;
}
@Component({
  selector: 'app-graphs',
  templateUrl: './graphs.component.html',
  styleUrls: ['./graphs.component.scss']
})

export class GraphsComponent {
@ViewChild('chartCanvas') chartCanvas:
    | ElementRef<HTMLCanvasElement>
    | undefined;

  chart: Chart | undefined;
  transformedData: any;
  secondchart!: Chart;
  filterOptions: any = [];
  chartDataSecond: any = [];
  dashboardForm: FormGroup;
  shipnameoptions: string[];
  monthOptions: string[];
  cargooptions: string[] = [];
  tankoptionsData!: string[];
  mergeGraph = [];
  recordsoptions: string[];
  tanks: string[] = [];
  vesselImo: string | null = '';
  vesselName: string | null = '';
  secondchartavg: any;
  avgGraph: boolean = false;
  datasets: any[] = [];
  showMeltPt: boolean = true;
  showLoadTemp: boolean = true;
  showCargoTemp: boolean = true;
  showVoyRange: boolean = true;
  showDischRange: boolean = true;
  showAirTemp = false;
  showSeaTemp = false;
  showForecastTemp = true;
  voyRangMax: any;
  voyRangMin: any;
  disRangMax: any;
  disRangMin: any;
  avgVoyMin: any;
  avgVoyMax: any;
  avgDisMin: any;
  avgDisMax: any;
  avgMeltpt: any;
  avgLoad: any;
  selectedTank: string | null = null;
  meltPt: any;
  tankData: any;
  tankoptions = ['Tank 1', 'Tank 2', 'Tank 3', 'Tank 4'];
  fetchAverageTemp: any;
  transformedApiData: any;
  filteredOptions: any;
  apiData: any;
  loadPort: any;
  cargo: any;
  tankDetailsArray: any;
  dischargePort: any;
  parsedDataTwo: any;
  gaugeData!: any;
  Melt_Pts: any;
  Voy_Range_Max: any;
  Disch_Range_Min: any;
  Disch_Range_Max: any;
  Voy_Range_Min: any;
  Load_Pts: any;
  forcastTemp: any;
  cargoTemp: any;
  axisDates: any;
  cargo_detail_list: any;
  selectedTankLabel: string = 'Avg Temp';
  selectedCargoLabel: string | undefined;
  isFilterSubmit = false
    public axisLabels: string[] = [];

  // Sample data arrays
  public ladenData: number[] = [10, 13, 14, 15, 18, 20, 19, 17];
  public ballastData: number[] = [11, 12, 13, 14, 19, 21, 20, 18];
  public goodWxLaden: number[] = [5, 8, 10, 12, 16, 20, 18, 15];
  public goodWxBallast: number[] = [4, 6, 9, 11, 14, 17, 15, 12];
  public fleetAvgLaden = 16;
  public fleetAvgBallast = 15;
  benchmarkChart: any;

  // Modern Filter State
  cargoSearchQuery: string = '';
  tankSearchQuery: string = '';
  recordsSearchQuery: string = '';
  cargoDropdownOpen = false;
  tankDropdownOpen = false;
  recordsDropdownOpen = false;
  selectedCargos: string[] = [];
  selectedTanks: string[] = ['Avg Temp'];
  constructor(
    private fb: FormBuilder,
    private commonService: CargoheatingCommonService,
    private toastr: ToastrService,

    private dialog: MatDialog,
    private router: Router,
    private cd: ChangeDetectorRef,
     private requestFormService: RequestFormService,
  ) {
    this.dashboardForm = this.fb.group({
      fromDate: [''],
      toDate: [''],
      cosp: [''],
      eosp: [''],
      shipname: [''],
      cargo: [''],
      tanks: [['Avg Temp']],
      records: [''],
      month: [''],
    });
    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.recordsoptions = getRecordsOptions();
  }

  ngOnInit(): void {
     this.axisLabels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    this.vesselImo = localStorage.getItem('vesselImo');
    this.vesselName = localStorage.getItem('vesselName');
    this.fetchTankData();
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  updateCharts() {
    this.isFilterSubmit = true;
    this.createCharts();
    this.secondBar();
  }

  fetchTankData(): void {
    let payload = {
      vessel_imo: localStorage.getItem('vesselImo'),
      month: localStorage.getItem('month'),
      vessel_name: localStorage.getItem('vesselName'),
    };
    this.commonService.getGraphData(payload).subscribe(
      (data: any) => {
        let avgTempresponse = data[1].avgtemp_data;
        this.fetchAverageTemp = avgTempresponse;

        let response = data[0].tankwise_data || [];
        if (response) {
          response.forEach((cargo: any) => {
            this.cargo_detail_list = cargo.cargo_detail_list;
            if (this.cargo_detail_list) {
              const detailsArray = this.cargo_detail_list.split(' / ');
              this.extractUniqueCargo(detailsArray);
            }
          });
          this.tankoptions = this.extractUniqueTanks(response);
          this.filterOptions = response;

          this.createCharts();
        }

        //   let avgTempresponse = JSON.parse(data[1].avgtemp_data)
        //      this.fetchAverageTemp = avgTempresponse;
        //      let response = JSON.parse(data[0].tankwise_data)
        //         response.forEach((cargo:any) => {
        //            let cargo_detail_list = cargo.cargo_detail_list;
        //            if (cargo_detail_list) {
        //              const detailsArray = cargo_detail_list.split(" / ");
        //              this.extractUniqueCargo(detailsArray);
        //            }
        //          });
        //          this.tankoptions = this.extractUniqueTanks(response);
        //          this.filterOptions = response;

        //          this.createCharts();
      },
      (error) => {
        this.toastr.warning(ToasterMessages.DataNotFount);
      }
    );
  }

  transformForcastData(apiData: any): TransformedForcastoData {
    const index = apiData.index;
    const data = apiData.data;
    const columns = apiData.columns;

    const transformedData: TransformedForcastoData = {};

    for (let i = 0; i < index.length; i++) {
      const key = index[i];
      const rowData = data[i];
      const cargoEntry: dataSecond = {
        air_temp: rowData[columns.indexOf('AIR TEMP')] || null,
        sea_water_temp: rowData[columns.indexOf('SEA WATER TEMP')] || null,
        forcast_temp:
          rowData[columns.indexOf('FORECAST TEMP - 1-PORT')] || null,
        master_dates: rowData[columns.indexOf('Master Date')] || null,
      };

      transformedData[key] = cargoEntry;
    }

    return transformedData;
  }
  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }
  data = {
    vessel_imo: '1234567',
    voyage_month: '2024-05',
    cargo: 'Palm Kernel Oil',
    from_date: '2024-05-04',
    to_date: '2024-05-20',
    tanks: ['2-PORT', '5-PORT', '5-STBD'],
  };
  print() {
    const dialogRef = this.dialog.open(PrintReportComponent, {
      width: '530px',
      height: '430px',
      autoFocus: false,
      restoreFocus: false,
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if (this.dashboardForm.get('cargo')?.value) {
        this.dashboardForm.get('tanks')?.setValue('');
      }
      const jsonData = {
        report_type: result.formData,
        vessel_imo: localStorage.getItem('vesselImo'),
        vessel_name: localStorage.getItem('vesselName'),
        month: localStorage.getItem('month'),
      };
      if (result.formData === 'report7') {
        let avgJson = {
          report_type: 'avg',
          vessel_imo: localStorage.getItem('vesselImo'),
          vessel_name: localStorage.getItem('vesselName'),
          voyage_month: localStorage.getItem('month'),
          Voy_Range_Min: this.fetchAverageTemp.Voy_Range_Min,
          Voy_Range_Max: this.fetchAverageTemp.Voy_Range_Max,
          Disch_Range_Min: this.fetchAverageTemp.Disch_Range_Min,
          Disch_Range_Max: this.fetchAverageTemp.Disch_Range_Max,
          Melt_Pts: this.fetchAverageTemp.Melt_Pts,
          Load_Pts: this.fetchAverageTemp.Load_Pts,
          master_dates: this.axisDates,
          cargo_temp: this.cargoTemp,
          fct_temp: this.forcastTemp,
        };
        console.log(this.filteredOptions, 'filter');
        let tankData = {
          report_type: 'tank',
          vessel_imo: localStorage.getItem('vesselImo'),
          vessel_name: localStorage.getItem('vesselName'),
          voyage_month: localStorage.getItem('month'),
          tank_data: this.filteredOptions
        };

        console.log(this.formCargoData, "form");
        console.log(this.formTankData, "form");
        this.printSelection(
          result.formData == 'report7'
            ? this.formTankData.includes('Avg Temp') && !this.formCargoData.length
              ? avgJson
              : tankData
            : jsonData
        );

      } else if (result.action !== "printAndSave") {
        this.printPdf(jsonData);

      } else {
         this.printPdf(jsonData);
        this.commonService
          .postreportTableData(jsonData)
          .subscribe((data) => { });
      }
    });

    // this.avgGraph = true;
  }
  printSelection(jsonData: any) {
    console.log(jsonData, "json")
    if (this.dashboardForm.get('tanks')?.value == 'All') {
      jsonData.tank_data = this.filteredOptions;

    }

    if (this.dashboardForm.get('cargo')?.value) {
      jsonData.tank_data = this.filteredOptions;


    }
    console.log(jsonData, "jsondata2")
    this.commonService.printSelection(jsonData).subscribe((response: any) => {
      const fileURL = window.URL.createObjectURL(response);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = fileURL;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    });
  }

  printSave(jsonData: any) {
    this.commonService.postPrintSave(jsonData).subscribe(
      (response: any) => {
        const fileURL = window.URL.createObjectURL(response);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = fileURL;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        };
      }
    );
  }
  printPdf(jsonData: any) {
    this.commonService.printPdf(jsonData).subscribe((response: any) => {
      console.log('Response from API:', response);
      const fileURL = window.URL.createObjectURL(response);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = fileURL;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    } , (error) => {
      this.toastr.info(ToasterMessages.RecordNotFount);
    });
  }
  reportClick() {
    this.router.navigate(['/ch-reportTable']);
  }

  // Modern Dropdown Toggles
  toggleCargoDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.cargoDropdownOpen = !this.cargoDropdownOpen;
    this.tankDropdownOpen = false;
    this.recordsDropdownOpen = false;
  }

  toggleTankDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.tankDropdownOpen = !this.tankDropdownOpen;
    this.cargoDropdownOpen = false;
    this.recordsDropdownOpen = false;
  }

  toggleRecordsDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.recordsDropdownOpen = !this.recordsDropdownOpen;
    this.cargoDropdownOpen = false;
    this.tankDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.cargoDropdownOpen = false;
    this.tankDropdownOpen = false;
    this.recordsDropdownOpen = false;
  }

  getFilteredCargos() {
    return this.cargooptions.filter(opt => opt.toLowerCase().includes(this.cargoSearchQuery.toLowerCase()));
  }

  getFilteredTanks() {
    return this.tankoptions.filter(opt => opt.toLowerCase().includes(this.tankSearchQuery.toLowerCase()));
  }

  getFilteredRecords() {
    return this.recordsoptions.filter(opt => opt.toLowerCase().includes(this.recordsSearchQuery.toLowerCase()));
  }

  // Cargo Selection
  clearCargoFilter(event?: Event) {
    if (event) event.stopPropagation();
    this.selectedCargos = [];
    this.dashboardForm.get('cargo')?.setValue([]);
    this.checkboxcargo = [];
  }

  toggleAllCargos(event: any) {
    if (event.target.checked) {
      this.selectedCargos = [...this.cargooptions];
    } else {
      this.selectedCargos = [];
    }
    this.dashboardForm.get('cargo')?.setValue(this.selectedCargos);
    this.checkboxcargo = this.selectedCargos;
  }

  isAllCargosSelected() {
    return this.selectedCargos.length === this.cargooptions.length && this.cargooptions.length > 0;
  }

  onCargoCheckboxChange(event: any, cargo: string) {
    if (event.target.checked) {
      this.selectedCargos.push(cargo);
    } else {
      this.selectedCargos = this.selectedCargos.filter(c => c !== cargo);
    }
    this.dashboardForm.get('cargo')?.setValue(this.selectedCargos);
    this.checkboxcargo = this.selectedCargos;
  }

  // Tank Selection
  clearTankFilter(event?: Event) {
    if (event) event.stopPropagation();
    this.selectedTanks = ['Avg Temp'];
    this.dashboardForm.get('tanks')?.setValue(['Avg Temp']);
    this.checkboxtank = ['Avg Temp'];
  }

  toggleAllTanks(event: any) {
    if (event.target.checked) {
      this.selectedTanks = [...this.tankoptions];
    } else {
      this.selectedTanks = ['Avg Temp'];
    }
    this.dashboardForm.get('tanks')?.setValue(this.selectedTanks);
    this.checkboxtank = this.selectedTanks;
  }

  isAllTanksSelected() {
    return this.selectedTanks.length === this.tankoptions.length && this.tankoptions.length > 0;
  }

  onTankCheckboxChange(event: any, tank: string) {
    if (event.target.checked) {
      if (tank !== 'Avg Temp') {
        this.selectedTanks = this.selectedTanks.filter(t => t !== 'Avg Temp');
      }
      this.selectedTanks.push(tank);
    } else {
      this.selectedTanks = this.selectedTanks.filter(t => t !== tank);
      if (this.selectedTanks.length === 0) {
        this.selectedTanks = ['Avg Temp'];
      }
    }
    this.dashboardForm.get('tanks')?.setValue(this.selectedTanks);
    this.checkboxtank = this.selectedTanks;
  }

  // Records Selection
  onRecordSelect(record: string) {
    this.dashboardForm.get('records')?.setValue(record);
    this.recordsDropdownOpen = false;
    this.updateCharts();
  }

  print1() {
    const dialogRef = this.dialog.open(PrintReportComponent, {
      width: '530px',
      height: '370px',
      autoFocus: false,
      restoreFocus: false,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
      }
    });

    this.avgGraph = true;

    const jsonData = {
      vessel_imo: '999999',
      voyage_month: 'Jan',
      Cargo: 'Palm Stearin',
      From_Date: '2024-05-04',
      To_Date: '2024-05-29',
      tanks: ['2-PORT'],
    };

    console.log('Sending JSON Data:', jsonData);

    this.commonService.printPdf(jsonData).subscribe(
      (response: any) => {
        console.log('Response from API:', response); // Log the response to check its structure

        // Adjust based on the actual response structure
        const base64String = response.data?.base64 || response.base64 || null;

        if (base64String) {
          try {
            const binaryString = atob(base64String);
            const binaryLen = binaryString.length;
            const bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            this.openPrintPreview(blobUrl);
          } catch (error) {
            console.error('Error decoding Base64 string:', error);
          }
        } else {
          console.error('Base64 string is missing in the response');
        }
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  openPrintPreview(blobUrl: string) {
    const printWindow = window.open(blobUrl, '_blank');
    if (!printWindow) {
    } else {
      printWindow.focus();
    }
  }
  extractUniqueCargo(data: any[]) {
    let uniqueCargo: string[] = [];
    const cargo = data[0].trim();
    if (cargo.toUpperCase() !== 'E M P T Y') {
      if (!this.cargooptions.includes(cargo)) {
        this.cargooptions.push(cargo);
      }
    }
    // });

    // return uniqueCargo;
  }

  extractTanks(data: any[]): string[] {
    let uniqueTanks: string[] = [];
    data.forEach((item) => {
      if (!uniqueTanks.includes(item.tank)) {
        uniqueTanks.push(item.tank);
      }
    });
    return uniqueTanks;
  }
  extractUniqueTanks(data: any[]): string[] {
    const uniqueTanksSet = new Set<string>();

    data.forEach((item) => {
      if (item.No_Tanks) {
        uniqueTanksSet.add(item.No_Tanks);
      }
    });

    const uniqueTanks = Array.from(uniqueTanksSet);

    return ['All', 'Avg Temp', ...uniqueTanks];
  }
  clearClick() {
    this.showCargoTemp = true;
    this.showForecastTemp = true;
    this.dashboardForm.reset();
    this.formTankData = ['Avg Temp'];
    this.formCargoData = [];
    this.checkboxcargo = [];
    this.checkboxtank = ['Avg Temp'];
    this.selectedCargos = [];
    this.selectedTanks = ['Avg Temp'];
    this.cargoSearchQuery = '';
    this.tankSearchQuery = '';
    this.recordsSearchQuery = '';
    this.dashboardForm.controls['tanks'].setValue(['Avg Temp']);
    this.dashboardForm.controls['cargo'].setValue([]);
    this.selectedTankLabel = 'Avg Temp';
    this.selectedCargoLabel = '';
    this.isFilterSubmit = true;
    this.createCharts();
    this.avgGraph = true;
    this.secondBar();
  }

  onSelectionChange(event: string[] = []): void {
    this.checkboxtank = event;
   const avgTempIndex = event.indexOf('Avg Temp');
   if (event.some((item: string) => item !== 'Avg Temp') && avgTempIndex > -1) {
      event.splice(avgTempIndex, 1);
    }
    this.selectedTankLabel = event.length > 0 ? event.join(', ') : 'Tanks';
    this.dashboardForm.controls['tanks'].setValue(event);
  }


  onSelectionChangeCargo(event?: any) {
    this.checkboxcargo = event;
    this.selectedCargoLabel = event.length > 0 ? event.join(', ') : 'Cargo';
    console.log(this.checkboxcargo, 'cargo')
  }
  chartInstances: Chart[] = [];
  checkboxtank: string[] = [];
  checkboxcargo: string[] = [];
  formTankData: any = [];
  formCargoData: any = [];
  createCharts(): void {

    const fromDate = this.dashboardForm.get('fromDate')?.value;
    const toDate = this.dashboardForm.get('toDate')?.value;

    const selectedCargo: string[] = this.checkboxcargo;
    const selectedTank: string[] = this.checkboxtank.length > 0 ? this.checkboxtank : ['Avg Temp'];
    const records = this.dashboardForm.get('records')?.value;
    console.log(selectedTank, "hhh");
    this.formTankData = selectedTank
    this.formCargoData = selectedCargo
    if (records === 'Past Records') {
      this.showCargoTemp = true;
      this.showForecastTemp = false;
    } else if (records === 'Forecast Records') {
      this.showCargoTemp = false;
      this.showForecastTemp = true;
    }

    const fromDateTimestamp = fromDate;
    const toDateTimestamp = toDate;

    this.avgGraph = false;
    this.filteredOptions = this.filterOptions;


    if ((selectedCargo.length === 0) && selectedTank.includes('Avg Temp')) {
      this.avgGraph = true;
      this.secondBar();
      return;
    }
    if (selectedTank.includes('All') && !selectedCargo.length) {
      console.log('1')
      this.filteredOptions = this.filterOptions;
    } else if (selectedCargo.length > 0 && !selectedTank.includes('Avg Temp') && !selectedTank.includes('All')) {
      console.log('3')
      this.filteredOptions = this.filterOptions.filter((item: any) => {

        return selectedTank.includes(item.No_Tanks);
      });
    } else if (selectedTank.length > 0 && !selectedCargo.length) {
      console.log('2')
      this.filteredOptions = this.filterOptions.filter(
        (item: any) => selectedTank.includes(item.No_Tanks)
      );
      if (this.filterOptions.length === 0) {
        this.avgGraph = false;
        this.secondBar();
      }
    } else if (
      selectedCargo.length > 0 && (selectedTank.includes('Avg Temp') ||
        selectedTank.includes('All'))
    ) {
      console.log('4')
      this.filteredOptions = this.filterOptions.filter((item: any) => {

        let cargo_detail_list = item.cargo_detail_list;
        if (cargo_detail_list) {

          const detailsArray = cargo_detail_list.split(' / ');
          return selectedCargo.some(item => detailsArray[0].includes(item));

        }
        return item;
      });
    }

    const chartContainer = document.getElementById('chartContainer');
    if (chartContainer) {
      chartContainer.innerHTML = '';
    }

    this.chartInstances.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });
    this.chartInstances = [];

    this.filteredOptions.forEach((item: any, index: number) => {
      const canvasId = `chart${index}`;
      const canvasElement = document.createElement('canvas');
      canvasElement.id = canvasId;
      chartContainer?.appendChild(canvasElement);

      const filteredData = item.master_dates.reduce(
        (acc: any, timestamp: number, i: number) => {
          if (
            (!fromDateTimestamp || timestamp >= fromDateTimestamp) &&
            (!toDateTimestamp || timestamp <= toDateTimestamp)
          ) {
            acc.dates.push(
              new Date(timestamp).toLocaleDateString(undefined, {
                day: '2-digit',
                month: 'short',
              })
            );
            acc.cargoTemp.push(item.cargo_temp[i]);
            acc.forecastTemp.push(item.fct_temp[i]);
            if (records === 'Forecast Records') {
              acc.forecastTemp.push(item.AVR_FCT[i]);
            }
          }
          return acc;
        },
        { dates: [], cargoTemp: [], forecastTemp: [] }
      );

      const limitedData = {
        dates: filteredData.dates.slice(-15),
        cargoTemp: filteredData.cargoTemp.slice(-15),
        forecastTemp: filteredData.forecastTemp.slice(-15),
      };

      const axisDates = limitedData.dates;
      this.cargoTemp = limitedData.cargoTemp;
      const forecastTemp = limitedData.forecastTemp;
      const meltPt = item.Melt_Pts ?? 0;
      const loadPt = item.Load_Pts ?? 0;
      const voyRangeMax = item.Voy_Range_Max ?? 0;
      const voyRangeMin = item.Voy_Range_Min ?? 0;
      const dischRangeMax = item.Disch_Range_Max ?? 0;
      const dischRangeMin = item.Disch_Range_Min ?? 0;

      const forecastTempFiltered = forecastTemp.map((temp: number, index: number) =>
        this.cargoTemp[index] === temp ? null : temp
      );
      
      console.log("Forecast Temp Filtered: ", forecastTempFiltered);
      
      
      
      
      const datasets: ChartDataset[] = [
        {
          label: 'Melt Pt',
          type: 'line',
          data: this.showMeltPt
            ? Array(this.cargoTemp.length).fill(meltPt)
            : [],
          backgroundColor: '#d100ab',
          borderColor: '#d100ab',
          borderWidth: 2,
          pointRadius: 0,
          hidden: !this.showMeltPt,
        },
        {
          label: 'Loaded Temp (°C)',
          data: this.showLoadTemp
            ? Array(this.cargoTemp.length).fill(loadPt)
            : [],
          type: 'line',
          backgroundColor: '#930c00',
          borderColor: '#930c00',
          borderWidth: 2,
          pointRadius: 0,
          hidden: !this.showLoadTemp,
        },
        {
          label: 'Voy Range',
          type: 'line',
          data: this.showVoyRange
            ? Array(this.cargoTemp.length).fill(voyRangeMax)
            : [],
          backgroundColor: 'rgba(255, 215, 130, 0.3)', // Light Amber Gold
          borderWidth: 0, 
          pointRadius: 0,
          fill: {
            target: { value: voyRangeMin },
            above: 'rgba(255, 215, 130, 0.3)', // Light Amber Fill
          },
          hidden: !this.showVoyRange,
        },
        {
          label: 'Disch Range',
          type: 'line',
          data: this.showDischRange
            ? Array(this.cargoTemp.length).fill(dischRangeMax)
            : [],
          backgroundColor: 'rgba(255, 200, 150, 0.3)', // Light Peach Orange
          borderWidth: 0, 
          pointRadius: 0,
          fill: {
            target: { value: dischRangeMin },
            above: 'rgba(255, 200, 150, 0.3)', // Light Peach Fill
          },
          hidden: !this.showDischRange,
        },
        
        {
          label: 'Cargo Temp',
          data: this.showCargoTemp ? this.cargoTemp : [],
          backgroundColor: '#36a2eb',
          borderColor: '#0493f3',
          borderWidth: 2,
          fill: true,
          pointRadius: 0,
          barPercentage: 0.95,
          categoryPercentage: 0.6,
          hidden: !this.showCargoTemp,
        },
        {
          label: 'Forecast Temp',
          data: this.showForecastTemp ? forecastTempFiltered : [],
          backgroundColor: 'rgba(153, 170, 181, 0.9)',
          borderColor: '#4B6587',
          borderWidth: 2,
          fill: true,
          pointRadius: 0,
          barPercentage: 0.95,
          categoryPercentage: 0.6,
          hidden: !this.showForecastTemp,
        },
      ];

      // Create chart
      setTimeout(() => {
        const allDataPoints = datasets.flatMap(
          (dataset) =>
            dataset.data.filter(
              (value: any): value is number => typeof value === 'number'
            ) // Type predicate
        );

        const maxTemperature =
          allDataPoints.length > 0 ? Math.max(...allDataPoints) : 0; // Fallback to 0 if no valid data points

        const yAxisMax = maxTemperature + 5;

        const chartInstance = new Chart(canvasId, {
          type: 'bar',
          data: {
            labels: axisDates,
            datasets: datasets,
          },
          options: {
            scales: {
              x: {
                stacked: false,
                ticks: {
                  color: '#F8F8FF',
                  stepSize: 1,
                  autoSkip: false,
                },
              },
              y: {
                title: {
                  display: false,
                  text: 'Temperature (°C)',
                },
                min: 0,
                max: yAxisMax,
                ticks: {
                  color: '#F8F8FF',
                  stepSize: 5,
                  callback: function (value: any) {
                    return value + ' °C';
                  },
                },
              },
            },
            responsive: true,
            plugins: {
              tooltip: {
                enabled: true,
                mode: 'index',
                intersect: false,
                callbacks: {
                  label: function (context) {
                    const label = context.dataset.label ?? '';
                    let tooltipLabel = label;
            
                    if (context.raw !== null) {
                      tooltipLabel += ': ' + context.raw + ' °C';
                    }
            
                    return tooltipLabel;
                  },
                },
              },
              legend: {
                display: false,
              },
            },
            
            interaction: {
              mode: 'nearest',
              axis: 'x',
              intersect: false,
            },
          },
        });
        

        this.chartInstances.push(chartInstance);
        this.isFilterSubmit = false;
      }, 100);
    });

  }
  updateChart() {
    if (this.secondchart) {
      this.secondchart.destroy();
    }
    this.createCharts();
    this.secondBar();
  }

  secondBar(): void {
    const fromDate = this.dashboardForm.get('fromDate')?.value;
    const toDate = this.dashboardForm.get('toDate')?.value;

    const fromDateTimestamp = fromDate;
    const toDateTimestamp = toDate;

    const filteredDate = this.fetchAverageTemp.master_dates.reduce(
      (acc: any, timestamp: number, i: number) => {
        if (
          (!fromDateTimestamp || timestamp >= fromDateTimestamp) &&
          (!toDateTimestamp || timestamp <= toDateTimestamp)
        ) {
          acc.dates.push(
            new Date(timestamp).toLocaleDateString(undefined, {
              day: '2-digit',
              month: 'short',
            })
          );
          acc.cargoTemp.push(this.fetchAverageTemp.cargo_temp[i]);
          acc.forecastTemp.push(this.fetchAverageTemp.fct_temp[i]);
        }
        return acc;
      },
      { dates: [], cargoTemp: [], forecastTemp: [] }
    );

    const seaWaterTempData = this.fetchAverageTemp.sea_water_temp;
    const airTempData = this.fetchAverageTemp.air_temp;
    this.forcastTemp = filteredDate.forecastTemp;
    this.cargoTemp = filteredDate.cargoTemp;
    const meltPt = this.fetchAverageTemp.Melt_Pts;
    const loadPt = this.fetchAverageTemp.Load_Pts;
    const voyageMin = this.fetchAverageTemp.Voy_Range_Min;
    const voyageMax = this.fetchAverageTemp.Voy_Range_Max;
    const dischRangeMin = this.fetchAverageTemp.Disch_Range_Min;
    const dischRangeMax = this.fetchAverageTemp.Disch_Range_Max;

    this.forcastTemp = filteredDate.dates.map((date: string, index: number) => {
      return filteredDate.cargoTemp[index]
        ? null
        : this.forcastTemp[index] ?? 0;
    });

    this.axisDates = filteredDate.dates;
    this.cargoTemp = filteredDate.cargoTemp.map((temp: number | null) => {
      if (temp !== null) {
        return Math.round(temp);
      } else {
        return 0;
      }
    });

    let lastAvgTempValue = null;
    let lastAvgTempDate = null;
    for (let i = this.cargoTemp.length - 1; i >= 0; i--) {
      if (this.cargoTemp[i]) {
        lastAvgTempValue = this.cargoTemp[i];
        lastAvgTempDate = this.fetchAverageTemp.master_dates[i];
        break;
      }
    }

    let lastForcastTempValue = null;
    let lastForcastTempDate = null;
    for (let i = this.forcastTemp.length - 1; i >= 0; i--) {
      if (this.forcastTemp[i] !== null) {
        lastForcastTempValue = this.forcastTemp[i];
        lastForcastTempDate = this.fetchAverageTemp.master_dates[i];
        break;
      }
    }

    this.gaugeData = {
      loadTemp: Math.round(this.fetchAverageTemp.Load_Pts),
      meltPt: Math.round(this.fetchAverageTemp.Melt_Pts),
      voyMin: Math.round(this.fetchAverageTemp.Voy_Range_Min),
      voyMax: Math.round(this.fetchAverageTemp.Voy_Range_Max),
      dischMin: Math.round(this.fetchAverageTemp.Disch_Range_Min),
      dischMax: Math.round(this.fetchAverageTemp.Disch_Range_Max),
      lastAvgTemp: {
        value: lastAvgTempValue,
        date: lastAvgTempDate
          ? new Date(lastAvgTempDate).toLocaleDateString()
          : null,
      },
      lastForcastTemp: {
        value: lastForcastTempValue,
        date: lastForcastTempDate
          ? new Date(lastForcastTempDate).toLocaleDateString()
          : null,
      },
    };

    this.avgVoyMin = Math.round(this.fetchAverageTemp.voyage_min);
    this.avgVoyMax = Math.round(this.fetchAverageTemp.voyage_max);
    this.avgDisMax = Math.round(this.fetchAverageTemp.discharge_max);
    this.avgDisMin = Math.round(this.fetchAverageTemp.discharge_min);
    this.avgMeltpt = Math.round(this.fetchAverageTemp.melt_pt);
    this.avgLoad = Math.round(this.fetchAverageTemp.load_temp);

    if (this.secondchart) {
      this.secondchart.destroy();
    }

    const temperatureRangePlugin = {
      id: 'temperatureRangePlugin',
      beforeDraw: function (chart: any, args: any, options: any) {
        const { ctx, chartArea, scales } = chart;
        if (!scales || !scales.y) {
          return;
        }

        const { yScale } = scales;
        const lowerBound = 20;
        const upperBound = 30;

        const lowerBoundPixel = yScale?.getPixelForValue(lowerBound);
        const upperBoundPixel = yScale?.getPixelForValue(upperBound);

        ctx.save();
        ctx.fillStyle = 'rgba(255, 0, 0, 0.2)';
        ctx.beginPath();
        ctx.moveTo(chartArea.left, upperBoundPixel);
        ctx.lineTo(chartArea.right, upperBoundPixel);
        ctx.lineTo(chartArea.right, lowerBoundPixel);
        ctx.lineTo(chartArea.left, lowerBoundPixel);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      },
    };

    setTimeout(() => {
      Chart.register(temperatureRangePlugin);

      this.secondchart = new Chart('secondCanvas', {
        type: 'bar',
        data: {
          labels: this.axisDates,
          datasets: [
            {
              label: 'Melt Pt',
              type: 'line',
              data: this.showMeltPt ? Array(this.cargoTemp.length).fill(meltPt) : [],
              backgroundColor: '#D45A00', // Rust Orange
              borderColor: '#D45A00',
              borderWidth: 2,
              pointRadius: 0,
              hidden: !this.showMeltPt,
            },
            {
              label: 'Loaded Temp (°C)',
              data: this.showLoadTemp ? Array(this.cargoTemp.length).fill(loadPt) : [],
              type: 'line',
              backgroundColor: '#930c00', // Emerald Green
              borderColor: '#930c00',
              borderWidth: 2,
              pointRadius: 0,
              hidden: !this.showLoadTemp,
            },
            {
              label: `Voy Range (${this.fetchAverageTemp.Voy_Range_Min} °C - ${this.fetchAverageTemp.Voy_Range_Max} °C)`,
              data: this.showVoyRange ? Array(this.cargoTemp.length).fill(voyageMin) : [],
              type: 'line',
              borderWidth: 2,
              pointRadius: 0,
              fill: false,
              backgroundColor: '#E6A800', // Amber Gold
              borderColor: '#B6D7A840',
              order: -2,
              hidden: !this.showVoyRange,
            },
            {
              label: 'Upper voyage Bound',
              data: this.showVoyRange ? Array(this.cargoTemp.length).fill(voyageMax) : [],
              type: 'line',
              pointRadius: 0,
              fill: '-1',
              backgroundColor: '#C1E7BF94', // Light Green
              borderColor: 'rgba(0, 0, 0, 0)',
              order: -0.1,
              hidden: !this.showVoyRange,
            },
            {
              label: `Disch Range (${this.fetchAverageTemp.Disch_Range_Min} °C - ${this.fetchAverageTemp.Disch_Range_Max} °C)`,
              data: this.showDischRange ? Array(this.cargoTemp.length).fill(dischRangeMin) : [],
              type: 'line',
              borderWidth: 2,
              borderColor: '#FFE6E640', // Soft Yellow
              pointRadius: 0,
              fill: false,
              backgroundColor: '#FFE6E6', // Light Red
              order: -2,
              hidden: !this.showDischRange,
            },
            {
              label: 'Upper Bound',
              data: this.showDischRange ? Array(this.cargoTemp.length).fill(dischRangeMax) : [],
              type: 'line',
              borderWidth: 2,
              borderColor: 'rgba(0, 0, 0, 0)',
              pointRadius: 0,
              fill: '-1',
              backgroundColor: '#EEAE5C94', // Soft Yellow
              order: -0.1,
              hidden: !this.showDischRange,
            },
            {
              label: 'Air Temp',
              data: airTempData,
              type: 'line',
              backgroundColor: '#FFAA33', 
              borderColor: '#FFAA33',
              borderWidth: 2,
              fill: false,
              pointRadius: 0,
              hidden: !this.showAirTemp,
            },
            {
              label: 'Sea Water Temp',
              data: seaWaterTempData,
              type: 'line',
              backgroundColor: '#33DDFF', 
              borderColor: '#33DDFF',
              borderWidth: 2,
              fill: false,
              pointRadius: 0,
              hidden: !this.showSeaTemp,
            },
            
            
            {
              label: 'Forecast Temp',
              data: this.forcastTemp,
              backgroundColor: 'rgba(153, 170, 181, 0.9)', // Sophisticated Slate Grey
              borderColor: 'rgba(153, 170, 181, 1)', // Smoky Blue-Grey border
              borderWidth: 2,
              fill: '-1',
              pointRadius: 0,
              barPercentage: 0.9,
              categoryPercentage: 0.6,
              hidden: !this.showForecastTemp,
            },
            {
              label: 'Cargo Temp',
              data: this.showCargoTemp ? this.cargoTemp : [],
              backgroundColor: '#004488', // Navy Blue
              borderColor: '#0493F3', // Slightly darker blue
              borderWidth: 2,
              fill: true,
              pointRadius: 0,
              barPercentage: 0.9,
              categoryPercentage: 0.6,
              hidden: !this.showCargoTemp,
            },
          ],
        },
        options: {
          scales: {
            x: {
              stacked: false,
              ticks: {
                color: '#F8F8FF',
                callback: function (value: any, index: number, ticks: any[]) {
                  const numericValue = typeof value === 'string' ? Number(value) : value;
                  return index % 3 === 0 ? this.getLabelForValue(numericValue) : '';
                },
              },
            },
            y: {
              title: {
                display: false,
                text: 'Temperature (°C)',
              },
              ticks: {
                color: '#F8F8FF',
                stepSize: 0,
                callback: function (value) {
                  return value + ' °C';
                },
              },
            },
          },
          responsive: true,
          plugins: {
            tooltip: {
              enabled: true,
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (context) {
                  const excludedLabels = ['Upper voyage Bound', 'Upper Bound'];
                  const label = context.dataset.label ?? '';
                  if (excludedLabels.includes(label)) {
                    return '';
                  }
                  if (label.includes('Voy Range') || label.includes('Disch Range')) {
                    return label;
                  }
                  let tooltipLabel = label;
                  if (label) {
                    tooltipLabel += ': ';
                  }
                  if (typeof context.raw === 'number') {
                    tooltipLabel += Math.round(context.raw) + ' °C'; // Display integer values
                  }
                  return tooltipLabel;
                },
              },
            },
            legend: {
              display: false,
            },
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true,
          },
        },
      });
      
    }, 1);
  }


  /** Applies a Light Mode host class so scoped light-theme styles can activate. */
  @HostBinding('class.ch-light') get chLight(): boolean {
    return !this.isDarkMode();
  }

  isDarkMode(): boolean {
    return this.requestFormService.isDarkMode();
  }

  fetchNewData() {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '430px',
      height: '325px',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.router.navigate(['/ch-home']);
      }
    });
  }
  applyFilters() {
    this.updateCharts();
  }

  clearFilters() {
    this.dashboardForm.reset({
      records: 'Both'
    });
    this.selectedCargos = [];
    this.selectedTanks = ['Avg Temp'];
    this.checkboxcargo = [];
    this.checkboxtank = ['Avg Temp'];
    this.updateCharts();
  }

  goBack() {
    this.router.navigate(['/ch-analyticsDashboard']);
  }
}
